export function h5Copy(value?: string | null) {
  return (value || '')
    .replaceAll('存积分', '添柴')
    .replaceAll('取积分', '取柴')
    .replaceAll('存分', '添柴')
    .replaceAll('取分', '取柴')
    .replaceAll('积分', '柴火')
    .replaceAll('POINTS', 'FIREWOOD')
}
